<o-loading [isLoading]="!displayReady"></o-loading>

<mat-form-field class="filter">
  <mat-label>{{ "tocItem.filter" | translate }}</mat-label>
  <input matInput type="text" title="filter" [formControl]="searchControl" />
</mat-form-field>

@if (displayReady) {
  @if (unfilteredData.length) {
    <div class="actions">
      <a (click)="toggleSelectionAll()">
        {{ (selectMode ? "actions.unselectAll" : "actions.selectAll") | translate }}
      </a>
      <div>
        <button title="delete menu" mat-icon-button color="primary" [matMenuTriggerFor]="deleteMenu">
          <mat-icon color="primary" svgIcon="delete"></mat-icon>
        </button>
        <button
          title="export menu"
          mat-icon-button
          color="primary"
          [matMenuTriggerFor]="exportMenu"
          [disabled]="!store.offlineSearchReady">
          <mat-icon color="primary" svgIcon="export"></mat-icon>
        </button>
      </div>
    </div>
  } @else {
    <div class="empty-message">
      {{ "empty.maintFolder" | translate }}
    </div>
  }
}

<mat-tree [dataSource]="dataSource" [treeControl]="maintFolderService.treeControl">
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    matTreeNodePadding
    [matTreeNodePaddingIndent]="maintFolderService.indentation">
    <div class="dmc">
      <div class="placeholder"></div>
      <o-orion-card
        [data]="node | orionCardFormatter: orionCardSource.MAINT_FOLDER"
        [routerLink]="'../du/' + node.dmc"
        oHistoric
        [historicData]="node"
        [from]="historySource.MAINT_FOLDER">
        <div action-left>
          <mat-checkbox
            disableRipple
            [name]="node._id"
            (click)="toggleSelection($event, node)"
            [checked]="maintFolderService.selectionModel.isSelected(node.id)" />
        </div>
      </o-orion-card>
    </div>
  </mat-tree-node>

  <mat-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodePadding
    [matTreeNodePaddingIndent]="maintFolderService.indentation">
    <div class="dmc">
      <button mat-icon-button (click)="toggleExpansion(node)">
        <mat-icon
          color="primary"
          [svgIcon]="maintFolderService.treeControl.isExpanded(node) ? 'minus-box-outline' : 'plus-box-outline'">
        </mat-icon>
      </button>
      <o-orion-card
        [data]="node | orionCardFormatter: orionCardSource.MAINT_FOLDER"
        [routerLink]="'../du/' + node.dmc"
        oHistoric
        [historicData]="node"
        [from]="historySource.MAINT_FOLDER">
        <div action-left>
          <mat-checkbox
            disableRipple
            [name]="node._id"
            (click)="toggleSelection($event, node)"
            [checked]="maintFolderService.selectionModel.isSelected(node.id)" />
        </div>
      </o-orion-card>
    </div>
  </mat-tree-node>
</mat-tree>

<mat-menu #exportMenu="matMenu">
  <button mat-menu-item (click)="exportSelection(true)">
    <mat-icon color="primary" svgIcon="export"></mat-icon>
    {{ "actions.export.all" | translate }}
  </button>
  <button mat-menu-item (click)="exportSelection()" [disabled]="!maintFolderService.selectionModel.selected.length">
    <mat-icon color="primary" svgIcon="export"></mat-icon>
    {{ "actions.export.selection" | translate }}
  </button>
</mat-menu>

<mat-menu #deleteMenu="matMenu">
  <button mat-menu-item (click)="deleteSelection(true)">
    <mat-icon color="primary" svgIcon="delete"></mat-icon>
    {{ "actions.delete.all" | translate }}
  </button>
  <button mat-menu-item (click)="deleteSelection()" [disabled]="!maintFolderService.selectionModel.selected.length">
    <mat-icon color="primary" svgIcon="delete"></mat-icon>
    {{ "actions.delete.selection" | translate }}
  </button>
</mat-menu>
